(function () {
  const settings = window.freeGiftSettings;
  if (!settings || !settings.gifts.length) return;

  let isEvaluating = false;
  let pendingReevaluate = false;

  async function getCart() {
    const res = await fetch('/cart.js', { cache: 'no-store' });
    return res.json();
  }

  async function addGift(variantId) {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1, properties: { _free_gift: 'true' } }]
      })
    });
  }

  async function setGiftQuantity(line, quantity) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    });
  }

  async function evaluateGifts() {
    // Agar pehle se ek evaluation chal rahi hai, to is baar sirf flag laga do
    // taake current evaluation khatam hone ke foran baad ek aur dafa check ho
    if (isEvaluating) {
      pendingReevaluate = true;
      return;
    }
    isEvaluating = true;

    try {
      const cart = await getCart();

      const realItems = cart.items.filter((item) => !item.properties?._free_gift);

      const subtotal = realItems.reduce((sum, item) => sum + item.line_price, 0) / 100;
      const totalQuantity = realItems.reduce((sum, item) => sum + item.quantity, 0);

      for (const gift of settings.gifts) {
        if (!gift.enabled || !gift.variantId) continue;

        const metric = gift.triggerType === 'quantity' ? totalQuantity : subtotal;

        // cart.items mein index (1-based line number) dhoondo jo is gift variant ka hai
        const lineIndex = cart.items.findIndex(
          (item) => item.variant_id === gift.variantId && item.properties?._free_gift
        );
        const isInCart = lineIndex !== -1;
        const currentQty = isInCart ? cart.items[lineIndex].quantity : 0;

        if (metric >= gift.threshold) {
          if (!isInCart) {
            await addGift(gift.variantId);
          } else if (currentQty !== 1) {
            // Agar kisi wajah se quantity 1 se zyada/kam ho gayi ho, to usay wapas 1 pe fix karo
            await setGiftQuantity(lineIndex + 1, 1);
          }
        } else if (isInCart) {
          await setGiftQuantity(lineIndex + 1, 0);
        }
      }
    } catch (err) {
      console.error('Free gift evaluation error:', err);
    } finally {
      isEvaluating = false;
      if (pendingReevaluate) {
        pendingReevaluate = false;
        evaluateGifts();
      }
    }
  }

  const originalFetch = window.fetch;
  window.fetch = function (...args) {
    const url = args[0]?.toString() || '';
    const isCartRequest =
      url.includes('/cart/add') ||
      url.includes('/cart/change') ||
      url.includes('/cart/update') ||
      url.includes('/cart/clear');

    const result = originalFetch.apply(this, args);

    if (isCartRequest && !url.includes('_free_gift')) {
      result.then(() => setTimeout(evaluateGifts, 500));
    }

    return result;
  };

  document.addEventListener('DOMContentLoaded', evaluateGifts);
  setInterval(evaluateGifts, 5000);
})();